<main class="wrapper" id="scroll-container">

    <section id="home" class="spy-section home-section">
        <app-home></app-home>
    </section>

    <section class="py-3 py-md-4 brand-section gray-bg" style="background-color: #CED4D9;">
        <app-brands></app-brands>
    </section>

    <section id="services" class="spy-section section">
        <app-services></app-services>
    </section>

    <!-- <section id="project" class="spy-section project-section section pt-0">
      <app-work></app-work>
    </section> -->

    <!-- <section class="section pt-0">
        <app-experience></app-experience>
      </section> -->

    <section id="about" class="spy-section about-section section">
        <app-about></app-about>
    </section>

    <!-- <section class="section effect-section">
        <app-testimonials></app-testimonials>
    </section> -->

    <section id="contactus" class="spy-section section contactus-section">
        <app-contact></app-contact>
    </section>

    <!-- Footer -->
    <footer class="footer">
        <div class="container">
            <p class="m-0 text-center">© 2025 copyright all right reserved</p>
        </div>
    </footer>
    <a href="#home" id="return-to-top"><i class="bi-arrow-up-circle-fill"></i></a>
    <!-- End Footer -->
</main>
<!-- Snigles
<div class="modal fade" id="project_1" tabindex="-1" aria-labelledby="project_1" aria-hidden="true">
    <div class="modal-dialog px-modal">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="single-project-box">
                    <div class="row align-items-start">
                        <div class="col-lg-7">
                            <img class="border" src="assets/img/popup-project-1.jpg" title="" alt="">
                        </div>
                        <div class="col-lg-5 pt-4 pt-lg-0">
                            <h4>Website Design for Marketing Agency Startup</h4>
                            <p class="mb-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
                                anim id est laborum.</p>
                            <div class="about-content">
                                <ul>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Type:</span>
                                        <span>Website</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Langages:</span>
                                        <span>PHP, HTML, CSS, JS</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Platform:</span>
                                        <span>WordPress</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Country:</span>
                                        <span>USA</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Live URL:</span>
                                        <span>www.example.com</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="project_2" tabindex="-1" aria-labelledby="project_2" aria-hidden="true">
    <div class="modal-dialog px-modal">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="single-project-box">
                    <div class="row align-items-start">
                        <div class="col-lg-7">
                            <img class="border" src="assets/img/popup-project-1.jpg" title="" alt="">
                        </div>
                        <div class="col-lg-5 pt-4 pt-lg-0">
                            <h4>Website Design for Marketing Agency Startup</h4>
                            <p class="mb-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
                                anim id est laborum.</p>
                            <div class="about-content">
                                <ul>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Type:</span>
                                        <span>Website</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Langages:</span>
                                        <span>PHP, HTML, CSS, JS</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Platform:</span>
                                        <span>WordPress</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Country:</span>
                                        <span>USA</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Live URL:</span>
                                        <span>www.example.com</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="project_3" tabindex="-1" aria-labelledby="project_3" aria-hidden="true">
    <div class="modal-dialog px-modal">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                <div class="single-project-box">
                    <div class="row align-items-start">
                        <div class="col-lg-7">
                            <img class="border" src="assets/img/popup-project-1.jpg" title="" alt="">
                        </div>
                        <div class="col-lg-5 pt-4 pt-lg-0">
                            <h4>Website Design for Marketing Agency Startup</h4>
                            <p class="mb-3">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                                nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit
                                anim id est laborum.</p>
                            <div class="about-content">
                                <ul>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Type:</span>
                                        <span>Website</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Langages:</span>
                                        <span>PHP, HTML, CSS, JS</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Platform:</span>
                                        <span>WordPress</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Country:</span>
                                        <span>USA</span>
                                    </li>
                                    <li class="d-flex">
                                        <span class="col-4 col-lg-3">Live URL:</span>
                                        <span>www.example.com</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
-->